import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CompanyPageStepLicenseScoringComponent } from './company-page-step-license-scoring.component';

@NgModule({
  declarations: [CompanyPageStepLicenseScoringComponent],
  imports: [CommonModule, FormsModule, DragDropModule],
  exports: [CompanyPageStepLicenseScoringComponent],
  entryComponents: [CompanyPageStepLicenseScoringComponent]
})
export class CompanyPageStepLicenseScoringModule { }
